import {
    CONSORS_CANCEL_SUBSCRIPTION_STATUSES,
    CONSORS_DOWNLOAD_SUBSCRIPTION_DOCUMENT_REQUEST_FAILURE_REASONS,
    CONSORS_DOWNLOAD_SUBSCRIPTION_DOCUMENT_REQUEST_STATUSES,
    CONSORS_SUBSCRIPTION_STATUSES,
    CONSORS_SUBSCRIPTION_VALIDATION_FAILURE_REASONS,
} from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// export type ConsorsSubscriptionsTableSchema = {
//     errors: Record<PropertyKey, unknown> | null;
//     failureReason: CONSORS_SUBSCRIPTION_VALIDATION_FAILURE_REASON | null;
//     loanRequestId: string;
//     status: CONSORS_SUBSCRIPTION_STATUS;
//     subscription: SchemaConsorsSubscription | null;
//     subscriptionIdentifier: string | null;
//     timestamp: number;
//     warning: Record<PropertyKey, unknown> | null;
// };

export const ConsorsSubscriptionsTableDefinitionZod = z.object({
    cancellationStatus: z.nativeEnum(CONSORS_CANCEL_SUBSCRIPTION_STATUSES).optional(),
    documentDownload: z
        .object({
            failureReason: z.nativeEnum(CONSORS_DOWNLOAD_SUBSCRIPTION_DOCUMENT_REQUEST_FAILURE_REASONS).optional(),
            status: z.nativeEnum(CONSORS_DOWNLOAD_SUBSCRIPTION_DOCUMENT_REQUEST_STATUSES),
        })
        .optional(),
    errors: z.record(z.unknown()).nullable(),
    failureReason: z.nativeEnum(CONSORS_SUBSCRIPTION_VALIDATION_FAILURE_REASONS).nullable(),
    loanRequestId: schemaId,
    status: z.nativeEnum(CONSORS_SUBSCRIPTION_STATUSES),
    subscription: z.record(z.unknown()).nullable(),
    subscriptionIdentifier: z.string().nullable(),
    timestamp: z.number(),
    warning: z.record(z.unknown()).nullable(),
});

export type ConsorsSubscriptionsTableSchema = z.infer<typeof ConsorsSubscriptionsTableDefinitionZod>;
